import React, { useState, useEffect } from 'react';
import { Divider, Box, Button, IconButton, Typography, Container, Toolbar, Paper, Tooltip, TextField, InputAdornment, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DataObjectIcon from '@mui/icons-material/DataObject';
import ArticleIcon from '@mui/icons-material/Article';
import PublishIcon from '@mui/icons-material/Publish';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import SearchIcon from '@mui/icons-material/Search';
import WorkspacesIcon from '@mui/icons-material/Workspaces';

import FormsModal from '../FormsModal/FormsModal';
import apiGatewayService from '../../common/services/apiGatewayService';
import localStorageService from '../../common/services/localStorage.service';
import utilityFunctions from '../../common/services/utilityFunctions';
import CircularLoader from '../Loader/Loader';
import PublishFormsModal from '../PublishFormsModal/PublishFormsModal';
import FormSectionsBuilder from '../FormBuilder/FormSectionsBuilder/FormSectionsBuilder';
import AddGroupModal from '../AddGroupModal/AddGroupModal';
import FormGroupSelector from '../FormGroupSelector/FormGroupSelector';
import CustomAlert from '../CustomAlert/CustomAlert';
import DeleteConfirmation from '../DeleteConfirmation/DeleteConfirmation';
import { useNavigate } from 'react-router-dom';
import ImportFormsModal from '../ImportFormsModal/ImportFormsModal';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import LockIcon from '@mui/icons-material/Lock';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import SortIcon from '@mui/icons-material/Sort';
import ActionToolbar from './ActionToolBar';
import RefreshIcon from '@mui/icons-material/Refresh';

import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import "ag-grid-community/styles/ag-theme-material.css"; // Optional Theme applied to the Data Grid
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional Theme applied to the Data Grid



const tableColumnToKeyMapping = {
'Name': "formName",
'Created By': "createdBy",
'Edited By': "lastEditedBy",
'Created On': "createdOn",
'Edited On': "lastEditedOn",
'Status': "route",
'Group': "groupName"
};


const Forms = (props) => {
  const [forms, setForms] = useState([]);
  const [isAddNew, setIsAddNew] = useState(false);
  const [isViewJSON, setIsViewJSON] = useState(false);
  const [isView, setIsView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [viewIndex, setViewIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const [cogntioUser, setCogntioUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isOnlyReadAccess, setIsOnlyReadAccess] = useState(false);
  const [isPublish, setIsPublish] = useState(false);
  const [filterFormName, setFilterFormName] = useState('');
  const [filterLastEditedOn, setFilterLastEditedOn] = useState('');
  const [filterCreatedOn, setFlterCreatedOn] = useState('');
  const [filterLastEditedBy, setFilterLastEditedBy] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterCreatedBy, setFilterCreatedBy] = useState(''); // New filter for createdBy
  const [filterGroupName, setFilterGroupName] = useState(''); // New filter for groupName
  const [currentForm, setCurrentForm] = useState(null);
  const [companyAlias, setCompanyAlias] = useState('');
  const [isAddGroup, setIsAddGroup] = useState(false); // New state for add group modal
  const [isFormGroupSelectorOpen, setIsFormGroupSelectorOpen] = useState(false); // New state for FormGroupSelector modal
  const [displayAlert, setDisplayAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [formToDelete, setFormToDelete] = useState(null);
  const [isImportForm, setIsImportForm] = useState(false);
  const [isOpenImportedForm, setIsOpenImportedForm] = useState(false);
  const [isSaveForm, setIsSaveForm] = useState(false);
  // State to store filtered forms
  const [filteredForms, setFilteredForms] = useState(forms);
  const [sortKey, setSortKey] = useState(null);

  // useEffect to apply filters whenever a filter value changes
  useEffect(() => {
    const applyFilters = () => {
      let updatedForms = forms.filter((form) => {
        const formNameMatches = !filterFormName || form.formName.toLowerCase().includes(filterFormName.toLowerCase());
        const lastEditedOnMatches = !filterLastEditedOn || form.lastEditedOn?.toLowerCase().includes(filterLastEditedOn.toLowerCase());
        const lastEditedByMatches = !filterLastEditedBy || form.lastEditedBy.toLowerCase().includes(filterLastEditedBy.toLowerCase());
        const statusMatches = !filterStatus || form.route.toLowerCase().includes(filterStatus.toLowerCase());
        const createdByMatches = !filterCreatedBy || form.createdBy?.toLowerCase().includes(filterCreatedBy.toLowerCase());
        const groupNameMatches = !filterGroupName || form.groupName?.toLowerCase().includes(filterGroupName.toLowerCase());
        const createdOnMatches = !filterCreatedOn || form.createdOn?.toLowerCase().includes(filterCreatedOn.toLowerCase());

        return formNameMatches && lastEditedOnMatches && lastEditedByMatches && statusMatches && createdByMatches && groupNameMatches && createdOnMatches;
      });

      if (sortKey){
        updatedForms = utilityFunctions.sortByKey(updatedForms, sortKey);
      }

      setFilteredForms(updatedForms);
    };

    applyFilters();
  }, [sortKey, forms, filterFormName, filterLastEditedOn, filterLastEditedBy, filterStatus, filterCreatedBy, filterGroupName, filterCreatedOn]);


  const navigate = useNavigate();

  const handleOpen = () => setOpen(true);
  const handleClose = async (alertObject) => {
    setAllFalse();
    setOpen(false);
    setIsPublish(false);
    await getAllForms();
    if(alertObject?.type && alertObject?.message) {
      setAlertMessageAndPopup(alertObject);
    };
  }
  

  const setAlertMessageAndPopup  = (alertObject) => {
    setDisplayAlert(true);
    setAlertMessage(alertObject.message);
    setAlertType(alertObject.type);
    setTimeout(() => setDisplayAlert(false), 6000);
  }

  const handleCloseWithGetAllForms = async () => {
    setAllFalse();
    setOpen(false);
    setIsPublish(false);
    await getAllForms();
  }

  useEffect(() => {
    const getCompanyAlias = async () => {
      try {
        const response = await apiGatewayService.getCompanyAlias();
        console.log("Company Alias Respons: ", response.data[0].companyAlias);
        setCompanyAlias(response.data[0].companyAlias || null);
      } catch (error) {
        console.error('Error getting company alias:', error);
      }
    };
    const getForms = async (user) => {
      try {
        const response = await apiGatewayService.getFormsData();
        const dataWithUpdatedKeyAndContent = response.data;
        dataWithUpdatedKeyAndContent.sort((a, b) => {
          if (a.formName < b.formName) return -1;
          if (a.formName > b.formName) return 1;
          return 0;
        });
        setForms(dataWithUpdatedKeyAndContent);
      } catch (error) {
        if (error.response && error.response.status === 403) {
          console.log("Forbidden error detected, redirecting to login...");
          navigate('/');
        } else {
          console.error('Error fetching forms:', error);
        }
      }
      setIsLoading(false);
    };

    const getFormsByGroup = async () => {
      try {
        const response = await apiGatewayService.getFormsByGroup(props.selectedGroupId);
        console.log("Get forms by group response: ", response);
        const dataWithUpdatedKeyAndContent = response.data;
        dataWithUpdatedKeyAndContent.sort((a, b) => {
          if (a.formName < b.formName) return -1;
          if (a.formName > b.formName) return 1;
          return 0;
        });
        setForms(dataWithUpdatedKeyAndContent);
      } catch (error) {
        console.error('Error fetching forms:', error);
      }
      setIsLoading(false);
    };


    const user = localStorageService.getObject('user');
    setCogntioUser(user);
    console.log("Is only red access: ", utilityFunctions.checkIfOnlyReadAccess(user));
    setIsOnlyReadAccess(utilityFunctions.checkIfOnlyReadAccess(user));
    getCompanyAlias();
    if (props.selectedGroupId!==''){
      getFormsByGroup();
    } else {
      getForms();
    }
  }, [props.selectedGroupId]);

  const getAllForms = async () => {
    try {
      setIsLoading(true);
      let response
      if(props.selectedGroupId) {
        response = await apiGatewayService.getFormsByGroup(props.selectedGroupId);
      } else {
        response = await apiGatewayService.getFormsData();
      };
      const dataWithUpdatedKeyAndContent = response.data;
      dataWithUpdatedKeyAndContent.sort((a, b) => {
        if (a.formName < b.formName) return -1;
        if (a.formName > b.formName) return 1;
        return 0;
      });
      setForms(dataWithUpdatedKeyAndContent); 
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching forms:', error);
    }
  };

  const setAllFalse = () => {
    setIsAddNew(false);
    setIsViewJSON(false);
    setIsView(false);
    setIsEdit(false);
    setViewIndex(null);
    setIsPublish(false);
    setIsAddGroup(false); // Reset isAddGroup when closing modals
    setIsDeleteModalOpen(false);
    setFormToDelete(null);
    setIsImportForm(false);
    setIsOpenImportedForm(false);
  };

  const handleAddNew = () => {
    setAllFalse();
    setIsAddNew(true);
    handleOpen();
  };

  const handleAddGroup = () => {
    setAllFalse();
    setIsAddGroup(true); // Open add group modal
  };

  const handleViewJSON = async (formData) => {
    setAllFalse();
    await getFormById(formData?.formId);
    setTimeout(() => {
      setIsViewJSON(true);
      setIsLoading(false);
    }, 300);
    setViewIndex(formData?.formId);
    handleOpen();
  };

  const handleView = async (formData) => {
    setAllFalse();
    setIsView(true);
    localStorageService.setObject('isCurrForm', 'true');
    let companyAlias;
    try {
      const response = await apiGatewayService.getCompanyAlias();
      console.log("Company Alias Respons: ", response.data[0].companyAlias);
      companyAlias = response?.data?.[0]?.companyAlias || null;
    } catch (error) {
      console.error('Error getting company alias:', error);
    }
    if (companyAlias!==null) {
      const newTab = window.open(`/displayForm/${companyAlias}/${formData?.formId}`, '_blank', 'noopener,noreferrer');
      if (newTab) newTab.opener = null;
    } else {
      setAlertMessageAndPopup({
        message: 'Please set company alias first',
        type: 'error'
      });
    }


  };

  const handleEdit = async (formData) => {
    setAllFalse();
    await getFormById(formData?.formId);
    setTimeout(() => {
      setIsEdit(true);
      setIsLoading(false);
    }, 300);
    setViewIndex(formData?.formId);
    handleOpen();
  };

  // Open delete modal and set the field to delete
  const openDeleteModal = (formData) => {
    console.log("formData: ", formData);
    setFormToDelete(formData);
    // setViewIndex(formData.formId);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (formToDelete) {
      try {
        const postData = {
          formIds: [formToDelete.formId],
        };
        console.log(postData);
        await apiGatewayService.deleteFormsData(postData);
        setAllFalse();
        setDisplayAlert(true);
        setAlertMessage('Form deleted successfully!');
        setAlertType('success');
        setTimeout(() => setDisplayAlert(false), 6000);
        await getAllForms();
        // const formsNew = forms.filter((_, index2) => index2 !== index);
        // setForms(formsNew);
      } catch (error) {
        console.error("Error: ", error);
        // alert('Form cannot be deleted');
        setDisplayAlert(true);
        setAlertMessage('Error in deleting form!');
        setAlertType('error');
        setTimeout(() => setDisplayAlert(false), 6000);
      }
    }
    handleClose();
  };

  const handlePublishForm = async (formData) => {
    console.log(formData?.formId);
    setAllFalse();
    setViewIndex(formData?.formId);
    setIsPublish(true);
  };

  const submitPublishForms = async (status) => {
    if (status !== 'cancel') {
      try {
        console.log(viewIndex);
        const formData = forms.filter((form)=> form.formId === viewIndex)[0] || null;
        console.log(formData);
        const postData = {
          forms: [{ 
              formId: decodeURIComponent(formData?.formId), 
              formName: decodeURIComponent(formData?.formName), 
              route: status, 
              lastEditedOn: formatDate(new Date()), 
              createdBy: formData?.createdBy,
              createdOn: formData?.createdOn || '',
              groupId: decodeURIComponent(formData?.groupId || ''),
              groupName: decodeURIComponent(formData?.groupName || '')
            }],
        };
        console.log("form to publish: ", postData);
        await apiGatewayService.postPublishFormsData(postData);
        setAllFalse();
        setDisplayAlert(true);
        setAlertMessage('Form published successfully!');
        setAlertType('success');
        setTimeout(() => setDisplayAlert(false), 6000);
      } catch (error) {
        console.error("Error: ", error);
        // alert('Form cannot be published.');
        setAlertMessage('Error in publishing form!');
        setAlertType('error');
        setTimeout(() => setDisplayAlert(false), 6000);
      }
    }
    setAllFalse();
    handleCloseWithGetAllForms();
  };

  function formatDate(date) {
    const pad = (number, length = 2) => String(number).padStart(length, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    const milliseconds = pad(date.getMilliseconds(), 3) + '000000';
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  }

  const getFormById = async (formId) => {
    setIsLoading(true);
    try {
      setIsView(formId);
      const response = await apiGatewayService.getFormById(formId);
      setCurrentForm(response.data);
      return response;
    } catch (error) {
      console.error('Error getting form by id: ', error);
    }
    setIsLoading(false);
  }

  // let filteredForms = forms.filter(form => {
  //   const formNameMatches = !filterFormName || form.formName.toLowerCase().includes(filterFormName.toLowerCase());
  //   const lastEditedOnMatches = !filterLastEditedOn || form.lastEditedOn?.toLowerCase().includes(filterLastEditedOn.toLowerCase());
  //   const lastEditedByMatches = !filterLastEditedBy || form.lastEditedBy.toLowerCase().includes(filterLastEditedBy.toLowerCase());
  //   const statusMatches = !filterStatus || form.route.toLowerCase().includes(filterStatus.toLowerCase());
  //   const createdByMatches = !filterCreatedBy || form.createdBy?.toLowerCase().includes(filterCreatedBy.toLowerCase());
  //   const groupNameMatches = !filterGroupName || form.groupName?.toLowerCase().includes(filterGroupName.toLowerCase());
  //   const createdOnMatches = !filterCreatedOn || form.createdOn?.toLowerCase().includes(filterCreatedOn.toLowerCase()); // New filter logic for createdOn
  
  //   return formNameMatches && lastEditedOnMatches && lastEditedByMatches && statusMatches && createdByMatches && groupNameMatches && createdOnMatches;
  // });

  // console.log('filteredForms: ', filteredForms);
  

  const handleGroupSubmit = async (groupName) => {
    console.log('Group Name:', groupName);
    try {
      const response = await apiGatewayService.postFormGroups({groupName});
      console.log("Post form group response: ", response);
      setAlertMessageAndPopup({
        message: 'Group created successfully!',
        type: 'success'
      });
    } catch(error){
      console.log('Error in posting form group: ', error);
      setAlertMessageAndPopup({
        message: 'Error in creating group!',
        type: 'error'
      });
    }
    setIsAddGroup(false); 
  };

  
  const handleAssignGroup = (form) => {
    console.log("index assign group: ", form);
    setAllFalse();
    setViewIndex(form?.formId);
    setIsFormGroupSelectorOpen(true); // Open FormGroupSelector modal
  };

  const closeGroupSelector = (alertObject) => {
    setIsFormGroupSelectorOpen(false);
    if(alertObject?.type && alertObject?.message) {
      setAlertMessageAndPopup(alertObject);
    };
  };

  const handleFormGroupSubmit = async (groupId) => {
    console.log("Group name to submit for form: ", groupId);
    console.log("viewIndex for group: ", viewIndex);
    if (viewIndex !== null) {
        try {
          const postData = {
            formIds: [viewIndex],
          }
          await apiGatewayService.assignFormGroup(groupId, postData);
          setIsFormGroupSelectorOpen(false);
          await props.updateFormGroups();
          handleCloseWithGetAllForms();
        } catch (error) {
          console.error('Error submitting group for form:', error);
        }
    };
  };

  const removeFormGroup = async () => {
    const selectedForm = forms[viewIndex];  
    try {
      const postData = {
        formIds: [selectedForm.formId],
      }
      await apiGatewayService.removeFormGroup(postData);
      setIsFormGroupSelectorOpen(false);
      await props.updateFormGroups();
      handleCloseWithGetAllForms();
    } catch (error) {
      console.error('Error submitting group for form:', error);
    }
  }

  const renderBreadcrumbs = () => {
    if (isAddNew) return "Forms / New";
    if (isEdit) return "Forms  / Edit";
    if (isOpenImportedForm) return "Forms  / New";
    return "Forms";
  };

  const handleImportForm = () => {
    setIsImportForm(true);
  };

  const handleSubmitImportedJsonFile = (form) => {
    console.log("This is the current form: ", form);
    setCurrentForm(form);
    setIsImportForm(false);
    console.log("isOpenImportedForm: ", isOpenImportedForm);
    setIsOpenImportedForm(true);
  };

  function formatDateForDisplay(dateString) {
    // Split the string to remove the nanoseconds part
    if(dateString === ''){
      return ''
    }
    return dateString.split('.')[0];
  };

  const handleSaveForm = (value) => {
    setIsSaveForm(value);
  };

  const sortByColumn = (column) => {
    if (sortKey === tableColumnToKeyMapping[column]){
      setSortKey(null);
    } else{
      setSortKey(tableColumnToKeyMapping[column]);
    }
  };
  const defaultColDef = {
    sortable: true,
    suppressMenu: true,
    unSortIcon: true,
  };

  // New Code for Ag Grid table
  const [colDefs, setColDefs] = useState([
    {
      // cellRenderer: put your components here
      // valueGetter: p => p.data.formName+ ' '+p.data.status, // if you want concatenated values
      field: "formName",
      headerName: "Name",
      flex: 1,
      filter: true,
      floatingFilter: true,
      // checkboxSelection: true,
      sortable: true,
      //pinned: 'left'
      // width: 180
    },
    {
      field: "createdBy",
      headerName: "Created By",
      flex: 1,
      filter: true,
      floatingFilter: true,
      // width: 180
    },
    {
      field: "createdOn",
      headerName: "Created On",
      flex: 1,
      filter: true,
      floatingFilter: true,
      valueFormatter: (params) => params.value ? params.value.split(" ")[0] : ""
      // width: 180
    },
    {
      field: "lastEditedBy",
      headerName: "Edited By",
      flex: 1,
      filter: true,
      floatingFilter: true,
      // width: 180
    },
    {
      field: "lastEditedOn",
      headerName: "Edited On",
      flex: 1,
      filter: true,
      floatingFilter: true,
      valueFormatter: (params) => params.value ? params.value.split(" ")[0] : ""
      // width: 180
    },
    {
      field: "route",
      headerName: "Status",
      flex: 1,
      filter: true,
      floatingFilter: true,
      // width: 180
    },
    {
      field: "groupName",
      headerName: "Group",
      flex: 1,
      filter: true,
      floatingFilter: true,
      // width: 180
    },
    {
        field: 'Options',
        flex: 1.5,
        cellRenderer: (params) => (
            <ActionToolbar
              handlePublishForm={() => handlePublishForm(params.data)}
              handleViewJSON={() => handleViewJSON(params.data)}
              handleView={() => handleView(params.data)}
              handleEdit={() => handleEdit(params.data)}
              handleAssignGroup={() => handleAssignGroup(params.data)}
              openDeleteModal={() => openDeleteModal(params.data)}
              data={params.data} // Pass the row index
              isOnlyReadAccess={isOnlyReadAccess} // Pass the access control flag
            />
          ),
          // width: 180
    }
  ]);

  const pagination = true;
  const paginationPageSize = 50;
  const paginationPageSizeSelector = [10, 100, 1000];

  const handleRefresh = async () => {
    console.log("Refresh button for the form has been pressed!");
    await getAllForms();
  }
  

  return (
    // <Container sx={{ padding: '0px', margin: 0, minWidth: '95%', height: '95%', display: 'flex', flexDirection: 'column'}}>
    <Container disableGutters id = 'HELLO CHECK' sx={{pl:0, pr: 0, margin: 0, minWidth: '100%', height: '90%', display: 'flex', flexDirection: 'column'}}>
      <Divider sx={{ borderBottomWidth: '2px', borderColor: 'var(--app-color)' }} />
      { (!isEdit && !isAddNew && !isOpenImportedForm) && <Toolbar 
        sx={{ 
          // backgroundColor: 'var(--app-color-headings)', 
          backgroundColor: 'white',
          borderRadius: "10px", 
          borderEndEndRadius: '0px', 
          borderEndStartRadius: '0px', 
          padding: '0px', 
          color: 'white', 
          position: 'sticky', // Keeps the toolbar fixed inside the scrollable container
          top: 0,  // Sticks the toolbar to the top of the container
          zIndex: 1000, // Ensures it stays on top of the table
          justifyContent: 'space-between'
        }}>         
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {(!isEdit && !isAddNew && !isOpenImportedForm) && (
            <>
            <Tooltip title="Refresh">
                <IconButton
                sx={{ color: 'var(--app-color)', p: '5px' ,mr: '10px'}}
                aria-label="edit"
                onClick={handleRefresh}
                disabled={isOnlyReadAccess}
                >
                <RefreshIcon sx={{ fontSize: '34px', fontWeight: 'bold'  }}/>
                </IconButton>
            </Tooltip>
              <Button sx={{
                backgroundColor: 'var(--app-color)',
                width: '130px',
                marginRight: '10px',
                ":hover": {
                  // backgroundColor: '#F0F4F4',
                  backgroundColor: 'var(--button-hover-color)',
                  // color: '#2b4252',
                },
                '&.Mui-disabled': {
                  backgroundColor: '#e0e0e0',
                  color: 'grey',
                },
              }} color="inherit" startIcon={<AddIcon />} onClick={handleAddNew} disabled={isOnlyReadAccess}>
                Add New
              </Button>
              <Button sx={{
                backgroundColor: 'var(--app-color)',
                width: '130px',
                marginRight: '10px',
                ":hover": {
                  // backgroundColor: '#F0F4F4',
                  backgroundColor: 'var(--button-hover-color)',
                  // color: '#2b4252',
                },
                '&.Mui-disabled': {
                  backgroundColor: '#e0e0e0',
                  color: 'grey',
                },
              }} color="inherit" startIcon={<AddIcon />} onClick={handleAddGroup} disabled={isOnlyReadAccess}>
                Add Group
              </Button>
              <Button sx={{
                backgroundColor: 'var(--app-color)',
                width: '130px',
                marginRight: '-23px',
                ":hover": {
                  // backgroundColor: '#F0F4F4',
                  backgroundColor: 'var(--button-hover-color)',
                  // color: '#2b4252',
                },
                '&.Mui-disabled': {
                  backgroundColor: '#e0e0e0',
                  color: 'grey',
                },
              }} color="inherit" startIcon={<ImportExportIcon />} onClick={handleImportForm} disabled={isOnlyReadAccess}>
                Import
              </Button>
            </>
          )}
         {/* {(isEdit || isAddNew || isOpenImportedForm) && 
            <Button sx={{
              backgroundColor: 'var(--app-color)',
              width: '130px',
              marginRight: '10px',
              ":hover": {
                // backgroundColor: '#F0F4F4',
                backgroundColor: 'var(--button-hover-color)',
                // color: '#2b4252',
              },
              '&.Mui-disabled': {
                backgroundColor: '#e0e0e0',
                color: 'grey',
              },
            }} color="inherit" startIcon={<SaveAltIcon />} onClick={handleSaveForm} disabled={isOnlyReadAccess}>
              Save
            </Button>
          }
          {(isEdit || isAddNew || isOpenImportedForm) && 
            <Button sx={{
              backgroundColor: 'var(--app-color)',
              width: '130px',
              marginRight: '10px',
              ":hover": {
                // backgroundColor: '#F0F4F4',
                backgroundColor: 'var(--button-hover-color)',
                // color: '#2b4252',
              },
              '&.Mui-disabled': {
                backgroundColor: '#e0e0e0',
                color: 'grey',
              },
            }} color="inherit" startIcon={<KeyboardBackspaceIcon />} onClick={handleClose} disabled={isOnlyReadAccess}>
              Back
            </Button>
          } */}
        </Box>
      </Toolbar>}
      {
      displayAlert &&
      <CustomAlert isOpen={displayAlert} message={alertMessage} type={alertType}></CustomAlert>
      }
      {
        isDeleteModalOpen &&
        <DeleteConfirmation
        isOpen={isDeleteModalOpen}
        handleClose={handleClose}
        submitDelete={handleConfirmDelete}
      />
      }
      {isLoading && <CircularLoader />}
      {(!isLoading && !isEdit && !isAddNew && !isOpenImportedForm) &&
        <div
                className="ag-theme-quartz" // Or replace with your custom theme name
                style={{
                     overflow: 'auto',
                     height: '75vh',
                    //  widht: '75vh',
                     minWidth: '1000px',
                    // '--ag-foreground-color': 'rgb(14, 68, 145)', // Grid text color
                    // '--ag-background-color': 'rgb(241, 247, 255)', // Grid background color
                    // '--ag-header-background-color': 'rgb(228, 237, 250)', // Header row background color
                    '--ag-header-background-color':  '#bcecff',
                    // '--ag-row-hover-color': 'rgb(216, 226, 255)', // Row hover color
                }}
            >
                <AgGridReact
                    // ref={gridRef} // Attach the ref
                    // onRowSelected={onRowSelected}
                    rowData={forms}
                    columnDefs={colDefs}
                    defaultColDef={defaultColDef} 
                    sideBar={true}
                    // rowSelection="multiple"
                    rowSelection="none"
                    domLayout="normal" // Dynamically adjusts the height of the grid based on its content
                    suppressHorizontalScroll={false} // Ensures horizontal scrolling is enabled
                    suppressColumnVirtualisation={false} // Ensure columns render correctly for scrolling
                    suppressRowTransform={true} // Fixes issues with row scrolling
                    pagination={pagination}
                    paginationPageSize={paginationPageSize}
                    // paginationPageSizeSelector={paginationPageSizeSelector}
           
                />
            </div>

      }

      {isAddNew && <FormSectionsBuilder form={{}} handleClose={handleClose} isNew={true} />}
      {isOpenImportedForm && <FormSectionsBuilder form={currentForm} handleClose={handleClose} isNew={true} />}
      {isEdit && <FormSectionsBuilder form={currentForm} handleClose={handleClose} isEditInput = {true} formIdInput = {viewIndex || null} />}
      {isViewJSON && <FormsModal open={open} handleClose={handleCloseWithGetAllForms} form={currentForm} isViewJSON={true} />}
      {isPublish && 
        <PublishFormsModal
          handleClose={handleClose}
          open={isPublish}
          submitPublishForms={submitPublishForms}
        />
      }
      {
        isAddGroup && <AddGroupModal
        open = {isAddGroup}
        handleClose = {handleClose}
        handleSubmit= {handleGroupSubmit}

        />
      }
      {
        isFormGroupSelectorOpen && <FormGroupSelector
          isOpen={isFormGroupSelectorOpen}
          handleClose={closeGroupSelector}
          submitGroup={handleFormGroupSubmit}
          groupName = {filteredForms[viewIndex]?.groupName || null}
          removeGroup = {removeFormGroup}
        />
      }
      {
        isImportForm && <ImportFormsModal
        open={isImportForm}
        handleClose={handleClose}
        submitJsonFile={handleSubmitImportedJsonFile}
      />
      }
    </Container>
  );
};

export default Forms;